import PropTypes from 'prop-types';
import { Alert } from '@smarterservices/smarter-ui';

const StepSuccessMessage = ({ 
  message,
}) => {

  return (
    <Alert
      variant="success"
      margin="none"
      variantScreenReaderLabel="Success Alert"
    >
      {message}
    </Alert>
  );
};

StepSuccessMessage.propTypes = {
  message: PropTypes.string.isRequired,
};

export default StepSuccessMessage;
